<div (click)="clicked.emit()">
  <mat-icon>arrow_back</mat-icon
  ><ng-container *ngIf="label?.length">{{ label }}</ng-container>
</div>
